import React from "react";
import { Leaf, BookOpen, HeartHandshake } from "lucide-react";
import { useLang } from "../i18n";
import { ABOUT_IMAGE, ABOUT_IMAGE_2 } from "../data";
import { useSettings } from "../SiteSettings";
import Reveal from "./Reveal";
import OliveBranch from "./OliveBranch";

const ICONS = [Leaf, BookOpen, HeartHandshake];

export const About = () => {
  const { t, lang } = useLang();
  const settings = useSettings();
  const ab = (settings.about && settings.about[lang]) || {};
  const p1 = ab.p1 || t.about.p1;
  const p2 = ab.p2 || t.about.p2;

  return (
    <section id="about" className="relative py-24 md:py-32 px-5 md:px-10 bg-qs-bg overflow-hidden">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        {/* Images */}
        <Reveal className="relative">
          <div className="relative">
            <img
              src={ABOUT_IMAGE}
              alt="Küchenchef bei der Arbeit"
              className="w-full h-[420px] md:h-[560px] object-cover shadow-2xl"
            />
            <img
              src={ABOUT_IMAGE_2}
              alt="Frisch gebackene Pizza"
              className="hidden sm:block absolute -bottom-12 -right-6 w-44 h-56 md:w-56 md:h-72 object-cover border-[6px] border-qs-bg shadow-xl"
            />
            <div className="absolute -top-6 -left-6 hidden md:flex flex-col items-center justify-center w-32 h-32 bg-qs-red text-white">
              <span className="font-cormorant text-4xl leading-none">10+</span>
              <span className="font-outfit text-[10px] tracking-widest uppercase mt-1 text-center px-2">
                {t.about.stat1}
              </span>
            </div>
          </div>
        </Reveal>

        {/* Text */}
        <div>
          <Reveal>
            <p className="font-outfit text-qs-red tracking-[0.3em] uppercase text-xs mb-4">
              {t.about.eyebrow}
            </p>
            <h2 className="font-cormorant text-3xl sm:text-4xl lg:text-5xl text-qs-text leading-tight">
              {t.about.title}
            </h2>
            <OliveBranch className="w-24 text-qs-gold my-6" />
          </Reveal>
          <Reveal delay={100}>
            <p className="font-outfit text-qs-text2 text-base md:text-lg leading-relaxed">
              {p1}
            </p>
            <p className="font-outfit text-qs-text2 text-base md:text-lg leading-relaxed mt-4">
              {p2}
            </p>
          </Reveal>

          <div className="grid sm:grid-cols-3 gap-6 mt-10">
            {t.about.values.map((v, i) => {
              const Icon = ICONS[i];
              return (
                <Reveal key={i} delay={150 + i * 100}>
                  <div className="group">
                    <Icon className="text-qs-gold mb-3" size={28} strokeWidth={1.4} />
                    <h3 className="font-cormorant text-xl text-qs-text mb-1">{v.t}</h3>
                    <p className="font-outfit text-sm text-qs-text2 leading-relaxed">{v.d}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
